/* eslint-disable no-param-reassign */

import { ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE } from '../../../../app/constants/accounts_campaigns_selector_list_type';

xplenty.controller('accountsCampaignsSelectorListController', [
  '$scope',
  '$sce',
  function ($scope, $sce) {
    $scope.isSelectedList = $scope.type === ACCOUNTS_CAMPAIGNS_SELECTOR_LIST_TYPE.SELECTED;

    $scope.searchText = {
      name: '',
    };

    $scope.highlight = function (text, search) {
      if (!search) {
        return $sce.trustAsHtml(text);
      }
      return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlighted">$&</span>'));
    };

    $scope.filterAccounts = function (account) {
      let show = false;
      const searchText = $scope.searchText.name.toUpperCase();
      if (searchText.length > 0) {
        const accountName = account.name.toUpperCase();
        if (accountName.indexOf(searchText) > -1) show = true;
        _.each(account.campaigns, function (campaign) {
          const campaignName = campaign.name.toUpperCase();
          if (campaignName.indexOf(searchText) > -1) {
            show = true;
            account.collapsed = false;
          }
        });
      } else {
        show = true;
      }
      return show;
    };
  },
]);
